import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DsLinkModule } from '@bmw-ds/components';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DsIconModule } from '@bmw-ds/components';
import { DsTagModule } from '@bmw-ds/components';

@Component({
  selector: 'app-stop-sale-cell-renderer',
  imports: [CommonModule, DsLinkModule, DsIconModule, DsTagModule],
  standalone: true,
  template: `
    <ds-link
      href="#"
      [label]="value"
      tone="critical"
      (click)="onLinkClick($event)"
    ></ds-link>
    <img
      *ngIf="showAirIcon"
      src="/assets/images/air.ico"
      (click)="onAirIconClick($event)"
      class="air-icon"
      alt="Air Link"
    />
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        gap: 6px;
      }
      .air-icon {
        width: 16px;
        height: 16px;
      }
    `,
  ],
})
export class hyperlinkWindowCellRenderer implements ICellRendererAngularComp {
  public value: any;
  public params!: ICellRendererParams;
  public showAirIcon: boolean = false;

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
    this.value = params.value;
    this.showAirIcon = this.shouldShowAirIcon(params);
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.params = params;
    this.value = params.value;
    this.showAirIcon = this.shouldShowAirIcon(params);
    return true;
  }

  onClick(event: Event): void {
    event.preventDefault();
  }

  // Called only when the text link is clicked
  onLinkClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    const field = String(this.params?.colDef?.field ?? '');

    if (field === 'BulletinNumber') {
      // Bulletin link → open bulletin URL only
      this.bulletinUrlDirecting(this.params);
    } else if (field === 'VINandAirLink') {
      // VIN link → open vin URL only
      this.vinUrlDirecting(this.params);
    } else {
      // Fallback: delegate to parent handler
      const handler =
        (this.params as any)?.onClick ||
        (this.params as any)?.colDef?.cellRendererParams?.onClick;
      if (typeof handler === 'function') {
        handler(this.params);
      }
    }
  }

  // Called only when the air icon is clicked
  onAirIconClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation(); // prevent link click from also firing
    this.airUrlDirecting(this.params);
  }

  bulletinUrlDirecting(params: ICellRendererParams<any, any, any>) {
    const url = String(params?.data?.BulletinUrl ?? '').trim();
    if (!url) {
      console.warn('No bulletinUrl available for row:', params?.data);
      return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  vinUrlDirecting(params: ICellRendererParams<any, any, any>) {
    const url = String(params?.data?.vinUrl ?? '').trim();
    if (!url) {
      console.warn('No vinUrl available for row:', params?.data);
      return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  airUrlDirecting(params: ICellRendererParams<any, any, any>) {
    const url = String(params?.data?.airUrl ?? '').trim();
    if (!url) {
      console.warn('No airUrl available for row:', params?.data);
      return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  private shouldShowAirIcon(params: any): boolean {
    const field = String(params?.colDef?.field ?? '');
    return field === 'VINandAirLink';
  }
}
